import React from "react";
import AllProjects from "../AllProjects";
import AllContacts from "../AllContacts";

export default function Projects() {
  return (
    <div className="flex flex-col">
      <div className="py-12 px-6 md:px-12">
        <AllProjects />
      </div>
      <AllContacts />
    </div>
  );
}
